export default {
  data() {
    return {
      link:$('#app-wrapper').attr('link'),
      is_editable_works: ($('#app-wrapper').attr('is_editable_works')==1),
      is_editor: ($('#app-wrapper').attr('is_editor')==1),
      to_artist_id: $('#app-wrapper').attr('artist_id'),
      to_gallery_id: $('#app-wrapper').attr('gallery_id'),
    }
  },

  computed: {
    title: {
      //значение заголовка по умолчанию. В SeoMix для pageheader
      get () {
        return this.$t("message.Works");
      }
    },
  },

  methods: {
    is_show_add_work(){
      if ( window._GL_works_show_add==='n' ) return false;
      return true;
    },
  },
}



//////////////////
// WEBPACK FOOTER
// ./src/components/NavBarArtistGalleryMix.js
// module id = null
// module chunks = 